// apps/crm/src/lib/edge-error-message.ts
//
// Traduz o erro de uma Edge Function em mensagem legível.
//
// Contexto (30/07/2026 — troca de plano): o supabase-js embrulha respostas
// >= 400 num FunctionsHttpError cuja `.message` é sempre "Edge Function
// returned a non-2xx status code". Telas que faziam `toast(error.message)`
// mostravam essa string ao usuário — sem dizer se foi permissão, plano
// inválido ou Stripe fora do ar. O código tipado (`{ error: "not_found" }`,
// ver supabase/functions/_shared/errors.ts) vive em `error.context`, e só
// `extractEdgeError` sabe lê-lo.

import { extractEdgeError, type EdgeErrorCode } from '@pps/supabase/payload';
import i18n from '@/i18n';

const MESSAGE_KEY_BY_CODE: Record<EdgeErrorCode, string> = {
  unauthorized: 'common.forbidden',
  forbidden: 'common.forbidden',
  invalid_request: 'common.invalidRequest',
  rate_limited: 'common.rateLimited',
  not_found: 'common.notFound',
  conflict: 'common.unexpectedError',
  rpc_error: 'common.unexpectedError',
  external_service: 'common.serviceError',
  credits_exhausted: 'common.serviceError',
  missing_config: 'common.missingConfig',
  sem_asaas: 'invoices.detail.asaas.erro.sem_asaas',
  sem_customer: 'invoices.detail.asaas.erro.sem_customer',
  asaas_indisponivel: 'invoices.detail.asaas.erro.asaas_indisponivel',
  internal_error: 'common.unexpectedError',
};

/** Mensagem pronta para toast a partir de um erro de `functions.invoke`. */
export async function edgeErrorMessage(err: unknown): Promise<string> {
  const code = await extractEdgeError(err);
  return i18n.t(MESSAGE_KEY_BY_CODE[code] ?? 'common.unexpectedError');
}
